import { apiRequest } from '../../../shared/services/apiClient';
import {
  CreateDmAutomationRuleRequest,
  DmAutomationListQuery,
  DmAutomationRule,
  PagedDmAutomationResult,
  UpdateDmAutomationRuleRequest,
  normalizeDmAutomationRule,
  normalizePagedDmAutomations,
} from '../types/DmAutomation';

const basePath = '/api/v1/dm-automations';

const buildQuery = (query: DmAutomationListQuery = {}): string => {
  const params = new URLSearchParams();
  if (query.channel) {
    params.set('channel', query.channel);
  }
  if (typeof query.isEnabled === 'boolean') {
    params.set('isEnabled', String(query.isEnabled));
  }
  params.set('page', String(query.page && query.page > 0 ? query.page : 1));
  params.set('pageSize', String(query.pageSize && query.pageSize > 0 ? query.pageSize : 50));
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};

export const listDmAutomations = async (
  query: DmAutomationListQuery = {},
): Promise<PagedDmAutomationResult> => {
  const payload = await apiRequest<any>(`${basePath}${buildQuery(query)}`);
  return normalizePagedDmAutomations(payload);
};

export const getDmAutomation = async (ruleId: string): Promise<DmAutomationRule> => {
  const payload = await apiRequest<any>(`${basePath}/${encodeURIComponent(ruleId)}`);
  return normalizeDmAutomationRule(payload);
};

export const createDmAutomation = async (
  request: CreateDmAutomationRuleRequest,
): Promise<DmAutomationRule> => {
  const payload = await apiRequest<any>(basePath, {
    method: 'POST',
    body: JSON.stringify(request),
  });
  return normalizeDmAutomationRule(payload);
};

export const updateDmAutomation = async (
  ruleId: string,
  request: UpdateDmAutomationRuleRequest,
): Promise<DmAutomationRule> => {
  const payload = await apiRequest<any>(`${basePath}/${encodeURIComponent(ruleId)}`, {
    method: 'PUT',
    body: JSON.stringify(request),
  });
  return normalizeDmAutomationRule(payload);
};

export const setDmAutomationEnabled = async (
  ruleId: string,
  isEnabled: boolean,
): Promise<DmAutomationRule> => {
  const payload = await apiRequest<any>(`${basePath}/${encodeURIComponent(ruleId)}/enabled`, {
    method: 'PATCH',
    body: JSON.stringify({ isEnabled }),
  });
  return normalizeDmAutomationRule(payload);
};

export const deleteDmAutomation = async (ruleId: string): Promise<void> => {
  await apiRequest<void>(`${basePath}/${encodeURIComponent(ruleId)}`, {
    method: 'DELETE',
  });
};
